<template>
  <div>
    <div class="container">
      <div class="c-header-wrap">
      <div class="c-header" v-if="routerName != '/supervise/viewVideo'">
        <div class="c-header-container">

          <h1 v-if="logoUrl !== ''" class="logo">
            <img class="logo-width" :src="logoUrl" alt="">
          </h1>
          <h1 v-else class="logo 313" >
            <template v-if="isOpen">
              <template v-if="isAgent">
              <router-link
                to="/supervise/"
                class="icon-logo-new"
                :class="{
                  'logo-lenovo': school_id === 20023,
                  'logo-new':school_id !== 20023,
                  'logo-en': language == 'en',
                  'logo-qimeng': appName == 'qimeng',
                  }"
                >
              </router-link>


            </template>
            <template v-else>
              <router-link
                to="/supervise/"
                class="icon-logo"
                :class="{ 'logo-lenovo': school_id == 20023,'logo-qimeng': appName == 'qimeng', }"
                >
              </router-link>
            </template>
            </template>
          </h1>
          <navbar></navbar>
        </div>
      </div>
      </div>
      <el-container>
        <section class="main-container">
          <StudentList :key="'studentList'" v-if="routerName == '/supervise/' || routerName == '/supervise/detail'"></StudentList>
          <transition name="fade" mode="out-in" v-if="routerName == '/supervise/detail' || routerName == '/supervise/wrong' || routerName == '/supervise/videoHandout' ||  routerName == '/supervise/viewVideo' ">
            <router-view :key="key" ></router-view>
          </transition>
        </section>
      </el-container>
    </div>
    <!--同时打开多个页面的弹框-->
    <OpenMultiplePage v-if="isShow" />
    <!--/.同时打开多个页面的弹框-->
  </div>
</template>

<script>
  import i18n from '@/i18n'
  import StudentList from "@/views/studentList/index";
  import Navbar from "@/views/layout/Navbar";
  import OpenMultiplePage from '@/components/openMultiplePage';
  import {getLogo} from '@/utils/auth'
  import { getQueryString } from '@/utils'
  export default {
    name: "layout",
    data() {
      return {
        routerName: "", // 路由名称
        isShow: false,
        school_id: -1,
        showImage: false,
        isOpen: false,
        logoUrl: '',
        isAgent: false, // 是否是代理商
        language: 'zh',
        appName:'',
      }
    },
    components: { StudentList, Navbar, OpenMultiplePage },
    watch: {
      '$route':'getPath'
    },
    created() {
      this.routerName = this.$route.path;
      this.school_id = sessionStorage.getItem('school_id') || -1
      i18n.locale = sessionStorage.getItem('Select-language') || 'zh'
      this.language = i18n.locale;

      if (this.routerName != '/videoHandout' && this.routerName != '/viewVideo') {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    async mounted() {
      const schoolId = JSON.parse(sessionStorage.getItem('TEACHER_INFO')).school_id;
      console.log(schoolId, 'accountId');
      // await getLogo(schoolId)
      this.showImage = true;
      const logo = JSON.parse(sessionStorage.getItem(`${schoolId}-ChangeLogoUrl`)) || {};
      this.logoUrl = logo.groundUrl || '';
      const teacherInfo = JSON.parse(sessionStorage.getItem('TEACHER_INFO'));
      if (teacherInfo.is_agent_school) {
        this.isAgent = teacherInfo.is_agent_school;
      }
      this.$nextTick(()=> this.isOpen = true)
      this.appName = getQueryString('app_name') || sessionStorage.getItem('supervise_app_name') || ''
      console.log(this.appName,999)
    },
    methods: {
      getPath () {
        this.routerName = this.$route.path;
        if (this.routerName != '/videoHandout' && this.routerName != '/viewVideo') {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      }
    },
    computed: {
      key() {
        return this.$route.name !== undefined ? this.$route.name +new Date() : this.$route +new Date()
      },
      computedLogoClass() {
        return function() {
          console.log('dadadad111111111')
          if (this.school_id == 20023) {
            console.log('dadadad2222')
            return 'icon-logo logo-lenovo'
          } else {
            console.log('dwdsdsd')
            return this.isAgent ? 'icon-logo-new' : 'icon-logo'
          }
        }
      }
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/theme-chalk/common/var";
  @import "~@/assets/scss/var";
  @import "~@/assets/scss/mixins";
  .c-header-wrap{
    height: 48px;
  }
  .c-header {
    position: fixed;
    width: 100%;
    left: 0;
    z-index: 1001;
    background: $--color-primary;
    .c-header-container {
      @include flexbox();
      max-width: $app-main-width;
      margin: 0 auto;
      .logo {
        width: 200px;
        overflow: hidden;
        transition: all 0.5s ease;
        -webkit-transition: all 0.5s ease;
        border-right: 1px solid rgba(255, 255, 255, 0.5);
        .logo-new {
          width: 125px;
          background-image: url(~@/assets/images/logo_new@2x.png);
          background-size: contain;
        }
        .logo-lenovo {
          width: 125px;
          background-image: url(~@/assets/images/logo_lenovo.png);
          background-size: contain;
        }
        .logo-en {
          background-image: url("~@/assets/images/logo_en.png");
          background-size: contain;
        }
        .logo-qimeng {
          background-image: url("~@/assets/images/icon-logo-qimeng@2x.png");
          background-size: contain;
          margin-top: 10px;
          &::after {
            content: "";
            position: absolute;
            top: -4px;
            right: -30px;
            width: 60px;
            height: 14px;
            background-image: url("~@/assets/images/icon-free@2x.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
        &-width {
          max-width: 160px;
          height: 32px;
        }
      }
    }
  }

  .main-container {
    @include flex();
    position: relative;
    background: #FAFCFD;
    overflow: hidden;
    .home-feedback{
      cursor: pointer;
      position: fixed;
      bottom:70px;
      right:15%;
      z-index:9999;
    }
  }

  .el-aside {
    width: 200px !important;
    transition: all 0.5s ease;
    -webkit-transition: all 0.5s ease;
  }

  .c-mini-aside .c-header .c-header-container .logo {
    width: 0;
    border-right: 0;
    transition: all 0.5s ease;
    -webkit-transition: all 0.5s ease;
  }

  .c-mini-aside .el-aside {
    width: 72px !important;

  }
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue